import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { UseFormReturn } from 'react-hook-form';

import { TextFieldElement } from 'components/muiInputWrappers';
import { useTranslation } from 'react-i18next';

export type FormFields = {
  numeroIncidente?: number;
  clientTicketNumber?: number;
};

type Props = {
  form: UseFormReturn;
};

function IncidentOrReq({ form }: Props) {
  const { t } = useTranslation('global');

  return (
    <Box>
      <Typography>
        {t('common.commonProperties.clientIncidentNumber')}:
      </Typography>
      <TextFieldElement
        control={form?.control}
        name="clientTicketNumber"
        placeholder={t('common.commonProperties.clientIncidentNumber')}
        size="small"
        style={{ width: '100%' }}
        type="text"
        validation={{
          minLength: {
            value: 1,
            message: t('ticket.messages.valueLessThan1')
          },
          maxLength: {
            value: 30,
            message: t('ticket.messages.valueLongerThan30')
          }
        }}
        variant="outlined"
      />
    </Box>
  );
}

export default IncidentOrReq;
